import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../app/store'
import {
  fetchLiveSearchItems,
  setSearchQuery,
  toggleIsSearch,
  toggleIsSearching,
} from '../../pages/live/LiveSlice'
import LiveSearch from '../../pages/live/components/LiveSearch'
import styles from './TopBar.module.css'
import SportBonusPlus from './SportBonusPlus'

const TopBar = (props:any) => {
  const dispatch = useDispatch()
  const isSearch = useSelector((state: RootState) => state.liveGames.isSearch)
  const isSearching = useSelector((state: RootState) => state.liveGames.isSearching)
  const searchQuery = useSelector((state: RootState) => state.liveGames.searchQuery)
  const searchItems = useSelector((state: RootState) => state.liveGames.searchItems)
  const searchItemsStatus = useSelector((state: RootState) => state.liveGames.searchItemsFetchStatus)
  const searchRef = useRef() as React.MutableRefObject<HTMLInputElement>

  const showSearch = (isSearching: boolean) => {
    if (!isSearching) dispatch(setSearchQuery({ text: '' }))
    dispatch(toggleIsSearch(isSearching))
    dispatch(toggleIsSearching(isSearching))
  }
  useEffect(() => {
    if (isSearch) {
      const search = searchRef.current
      if (search && isSearching) search.focus()

      if (searchQuery.length > 2) {
        dispatch(fetchLiveSearchItems(searchQuery))
      }
    }
  }, [dispatch, isSearch, isSearching, searchQuery])
  
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(setSearchQuery({ text: e.target.value }))
    //dispatch(fetchLiveSearchItems())
  }

  const onFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    dispatch(toggleIsSearching(true))
  }

  return (
    <div className={styles.topBarContainer}>
      {isSearch ? (
        <>
          <div className={styles.searchContainer}>
            <div className={styles.searchIcon}></div>
            <input
              ref={searchRef}
              type="text"
              value={searchQuery}
              className={styles.searchInput}
              placeholder="მოძებნეთ სასურველი თამაში"
              onChange={onChange}
              onFocus={onFocus}
            />
            <div
              className={styles.searchClose}
              onClick={() => {
                showSearch(false)
              }}
            >
              
            </div>
          </div>
          {searchQuery.length > 2 ? (
            <LiveSearch searchItems={searchItems} />
          ) : (
            ''
          )}
        </>
      ) : (
        <>
          <div
            className={styles.searchButton}
            onClick={() => {
              showSearch(true)
            }}
          >
            
          </div>
          <SportBonusPlus />
        </>
      )}
    </div>
  )
};

export default TopBar